module.exports = __webpack_public_path__ + "static/media/feedback-thumbs-down.8a959d08.svg";